import apiClient from '../../apis';

/** One registry entry as `GET /api/pipeline-agents` states it (#1517): the agent registry's own words. */
export interface AgentAbout {
  owns: string;
  never: string;
  tools: Array<{ name: string; does: string }>;
  may_call: string[];
}

export interface DataLimits {
  rows_per_extract: number;
  rows_when_unlimited: number;
  rows_most_asked: number;
  bundled_seconds_per_query: number | null;
  warehouses: Array<{ name: string; provider: string; seconds_per_query: number | null; rows_per_query: number }>;
}

export interface DiscoverLimits {
  candidate_queries: number;
  labelling_queries: number;
  seconds_per_query: number;
}

export interface PipelineAgents {
  data: { about: AgentAbout; limits: DataLimits };
  discover: { about: null; limits: DiscoverLimits; connections: Array<{ id: string; name: string; provider: string }> };
  catalog: { about: AgentAbout; limits: null };
}

export const getPipelineAgents = async (): Promise<PipelineAgents> => {
  // the shared client has already unwrapped the `{success, data}` envelope
  const { data } = await apiClient.get('/api/pipeline-agents');
  if (!data?.data?.limits || !data.discover?.limits || !data.catalog) throw new Error('the agents could not be read');
  return data;
};

export interface UsageFigures { asks: number; askers: number; cost_usd: number; warehouse_bytes: number | null }
export interface UsageWeek {
  week: string;
  total: UsageFigures | null;
  withheld: boolean;
  breakdown?: { dimension: string; withheld: boolean; groups: Array<UsageFigures & { value: string }> };
}

/** The route breakdown of closed weeks (S15's admin read). `null`: the caller is not a workspace admin. */
export const getRouteUsage = async (weeks = 4): Promise<UsageWeek[] | null> => {
  try {
    const { data } = await apiClient.get('/api/usage/weekly', { params: { dimension: 'route', weeks } });
    if (!Array.isArray(data?.weeks)) throw new Error('the counts could not be read');
    return data.weeks;
  } catch (e: any) {
    if (e?.response?.status === 403) return null;
    throw e;
  }
};
